export enum MandatoryLinkType {
    costCenter = 0,
    department = 1,
    businessUnit = 2,
    jobDescription = 3,
    userGroup = 4
}
